import "./localizeYup";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { i18nAssetManager } from "./assetManager";

const baseUrl = import.meta.env.BASE_URL;
const baseUrlPresent = baseUrl.length > 0 && baseUrl !== "/";

// Get the appropriate load path for the current environment
const getBackendOptions = async () => {
  const loadPath = await i18nAssetManager.getLoadPath();
  if (typeof loadPath === "function") {
    return { loadPath };
  }

  return baseUrlPresent ? { loadPath: `${baseUrl}${loadPath}` } : { loadPath };
};

// Initialize i18n with dynamic backend options
void getBackendOptions().then((backendOptions) => {
  void i18n
    // This HTTP backend will load translation files using HTTP. Files are processed at build time for cache-busting
    // See the docs: https://github.com/i18next/i18next-http-backend
    .use(Backend)

    // The language detector determines the user's language from their browser. See the docs:
    // https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)

    .use(initReactI18next)
    .init({
      // info on load property:
      // https://github.com/i18next/i18next-http-backend?tab=readme-ov-file#seeing-failed-http-requests-like-404
      load: "languageOnly",
      backend: backendOptions,
      fallbackLng: "en",
      // avoids page flashing when a component tries to fetch a translation file that's not yet loaded
      ns: ["countries", "errors", "translation", "validation"],
      interpolation: {
        escapeValue: false,
      },
    });
});

export default i18n;
